import { render } from "./InputNumberSimple.vue?vue&type=template&id=16a97e99&ts=true"
import script from "./InputNumberSimple.vue?vue&type=script&lang=ts"
export * from "./InputNumberSimple.vue?vue&type=script&lang=ts"

import "./InputNumberSimple.vue?vue&type=style&index=0&id=16a97e99&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__